import { defineComponent as c, createBlock as r, openBlock as o, unref as l, mergeProps as p, withCtx as i, createElementVNode as e } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ c({
  name: "IconFingerprint",
  __name: "IconFingerprint",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (s, a) => (o(), r(l(m), p(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...a[0] || (a[0] = [
        e("path", { d: "M3.692 12.036a8.308 8.308 0 0 1 16.616 0 .75.75 0 1 0 1.5 0c0-5.417-4.391-9.808-9.808-9.808s-9.808 4.391-9.808 9.808a.75.75 0 1 0 1.5 0" }, null, -1),
        e("path", { d: "M6.72 10.8c.083-1.043.766-2.125 1.85-2.94 1.078-.807 2.463-1.279 3.802-1.179a5.39 5.39 0 0 1 4.974 5.778l-.033.454c-.068.958-.127 1.79-.356 2.72-.261 1.057-.751 2.265-1.773 3.867a.75.75 0 0 0 1.264.807c1.093-1.713 1.658-3.071 1.965-4.315.263-1.064.33-2.03.397-2.984l.032-.437a6.89 6.89 0 0 0-6.358-7.386c-1.75-.13-3.488.482-4.814 1.475-1.318.989-2.319 2.426-2.446 4.021l-.02.248v.001c-.064.825-.121 1.552-.332 2.198-.217.662-.586 1.197-1.32 1.569a.75.75 0 0 0 .678 1.338c1.15-.583 1.75-1.473 2.067-2.44.271-.829.341-1.742.402-2.533a78.017 78.017 0 0 1 .02-.261" }, null, -1),
        e("path", { d: "M12.022 9.788a2.445 2.445 0 0 0-2.452 2.438v.817c-.062 2.463-1.641 3.818-3.547 5.453l-.222.19a.75.75 0 1 1-.978-1.137c2.135-1.836 3.199-2.767 3.247-4.535v-.788a3.945 3.945 0 0 1 3.952-3.938c2.18 0 3.952 1.76 3.952 3.938v.012c-.031 2.01-.316 3.673-1 5.185-.684 1.512-1.743 2.819-3.239 4.158a.75.75 0 0 1-1-1.118c1.396-1.25 2.3-2.394 2.873-3.659.572-1.264.836-2.703.866-4.583a2.445 2.445 0 0 0-2.452-2.433" }, null, -1),
        e("path", { d: "M12.75 12.02a.75.75 0 1 0-1.5.033c.04 1.752-.29 3.046-.916 4.159C9.7 17.34 8.73 18.336 7.396 19.448a.75.75 0 1 0 .96 1.152c1.383-1.152 2.517-2.286 3.286-3.653.777-1.383 1.152-2.95 1.108-4.927" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
